import { render, staticRenderFns } from "./vip-tab-zgz.vue?vue&type=template&id=39ddb76c&scoped=true&"
import script from "./vip-tab-zgz.vue?vue&type=script&lang=js&"
export * from "./vip-tab-zgz.vue?vue&type=script&lang=js&"
import style0 from "./vip-tab-zgz.vue?vue&type=style&index=0&id=39ddb76c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ddb76c",
  null
  
)

export default component.exports